import React from "react"
import "./style.scss"
import LearnMore from "../../elements/learnmore/LearnMore"
import { GatsbyImage } from "gatsby-plugin-image"
import { Button, useTheme, makeStyles } from "@material-ui/core"
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import TrendingFlatIcon from '@material-ui/icons/TrendingFlat';
import _ from 'lodash';
import { navigate } from "gatsby"

// import Accordion from "react-bootstrap/Accordion"

// import { useAccordionToggle } from "react-bootstrap/AccordionToggle"
// import ShowMoreIcon from "../../../images/Icon-showmore.svg"

// const Toggle = ({ children, eventKey }) => {
//   const decoratedOnClick = useAccordionToggle(eventKey, () => {
//     if (document.getElementById("showMore").style.display === "none") {
//       document.getElementById("showMore").style.display = "block"
//     } else {
//       document.getElementById("showMore").style.display = "none"
//     }
//   })

//   return (
//     <div className="angle" onClick={decoratedOnClick}>
//       {children}
//     </div>
//   )
// }

const useStyles = makeStyles(theme => ({
  moreBtn: {
    textAlign: 'start',
    [theme.breakpoints.down(427)]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  readmoreBtn: {
    borderRadius: '6.4225px',
    borderWidth: 'medium',
    borderColor: '#00507f',
    textTransform: 'none',
    [theme.breakpoints.down(425)]: {
      width: '132px !important',
      whiteSpace: 'nowrap !important',
    },
  },
  bookdemoBtn: {
    borderRadius: '6.4225px',
    background: 'linear-gradient(108deg, #00507f 0%, #15b09a 100%)',
    textTransform: 'none',
    color: '#FFFFFF',
    [theme.breakpoints.down(425)]: {
      // width: '132px !important',
      whiteSpace: 'nowrap !important',
    },
  },
  Lists: {
    marginBottom:'15px'
  },
  list: {
    display: 'flex',
    marginBottom: '0px',
  },
  iconImg: {
    marginBottom: '15px',
    [theme.breakpoints.down(576)]: {
      marginBottom: '10px',
    },
  },
  text: {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '19px',
    lineHeight: '30px',
    marginLeft: '10px',
    marginTop: '5px',
    color: '#000000',
    [theme.breakpoints.down(576)]: {
      fontSize: '14px',
    },
  },
  descriptionTitle: {
    textAlign: 'left !important',
    marginBottom: '20px !important',
    [theme.breakpoints.up(640)]: {
      whiteSpace: 'nowrap !important',
    },
  },
}))

const Description = ({ title, descriptionText, descriptionText2, descriptionText3, list, learn_more_url, type, btnLabel, btnLink }) => {
  const classes = useStyles()
  const theme = useTheme()
  return (
    <>
    {!_.isEmpty(list) ? (
    <>
    <div className="solution-description">
      <div>
        <p className={classes.descriptionTitle} >{descriptionText}</p>
        <ul className={classes.Lists}>
          {list && list.map((data, index)=>{
            return(
            <li className={classes.list}>
              <img className={classes.iconImg} src={data.icon} alt={data.content} />
              <div className={classes.text}>{data.content}</div>
            </li>
            )
          })}
        </ul>
        <p style={{ textAlign: "left" }}>{descriptionText2}</p>
      </div>
      {!_.isEqual(type, 'management') && !_.isEqual(type, 'enterprise') &&
      <div className={classes.moreBtn}>
      <Button className={classes.readmoreBtn} variant="outlined" onClick={()=> navigate(`${learn_more_url}`)} endIcon={<TrendingFlatIcon />}> Read More </Button>&nbsp;&nbsp;&nbsp;
      <Button className={classes.bookdemoBtn} variant="contained"  onClick={()=> navigate(`${btnLink}`)}>{btnLabel}</Button>
      </div>}
    </div> 
    </>
    ) : (
      <div className="solution-description">
      <div>
        {title &&
        <h3 className="solution-title" style={{ textAlign: "left" }}>
          {title}
        </h3>}
        <p style={{ textAlign: "left" }}>{descriptionText}</p>
        <p style={{ textAlign: "left" }}>{descriptionText2}</p>
        <p style={{ textAlign: "left" }}>{descriptionText3}</p>
      </div>
      {/* <LearnMore text="Learn more" withArrow url={learn_more_url} /> */}
      {!_.isEqual(type, 'management') && !_.isEqual(type, 'enterprise') &&
      <div className={classes.moreBtn}>
      <Button className={classes.readmoreBtn} variant="outlined" onClick={()=> navigate(`${learn_more_url}`)} endIcon={<TrendingFlatIcon />}> Read More </Button>&nbsp;&nbsp;&nbsp;
      <Button className={classes.bookdemoBtn} variant="contained" onClick={()=> navigate(`${btnLink}`)}>{btnLabel}</Button>
      </div>}
    </div> )
    }
    </>
  )
}
const SolutionFeature = ({
  featureTitle,
  featureDescription,
  featureDescription2,
  featureDescription3,
  list,
  productImage,
  imageDirection,
  hack,
  url,
  stylePadding,
  type,
  btnLabel, 
  btnLink,
}) => {
  if (imageDirection !== "right") {
    return (
      <>
      <div className="highScreen">
        <div
          className={`solution-item ${imageDirection ? imageDirection : ""} ${
            hack ? hack : ""
          }`}
          style={{ justifyContent: "center", display: "flex" }}
        >
            <div className="img-container">
              <img src={productImage} alt={featureTitle} />
            </div>
            <Description
              title={featureTitle}
              descriptionText={featureDescription}
              descriptionText2={featureDescription2}
              descriptionText3={featureDescription3}
              list={list}
              learn_more_url={url}
              type={type}
              btnLabel={btnLabel}
              btnLink={btnLink}
            />
        </div>
      </div>
      <div className="lowScreen">
        <div
          className={`solution-item ${imageDirection ? imageDirection : ""} ${
            hack ? hack : ""
          }`}
          style={{ justifyContent: "center", display: "flex" }}
        >
            <Description
              title={featureTitle}
              descriptionText={featureDescription}
              descriptionText2={featureDescription2}
              descriptionText3={featureDescription3}
              list={list}
              learn_more_url={url}
              type={type}
              btnLabel={btnLabel}
              btnLink={btnLink}
            />
            <div className="img-container">
              <img src={productImage} alt={featureTitle} />
            </div>

        </div>
      </div>
      </>
    )
  }
  return (
    <>
    <div className="highScreen">
      <div
        className={`solution-item ${imageDirection ? imageDirection : ""} ${
          hack ? hack : ""
        }`}
        style={{ textAlign: "center" }}
      > 
          <Description
            title={featureTitle}
            descriptionText={featureDescription}
            descriptionText2={featureDescription2}
            descriptionText3={featureDescription3}
            list={list}
            learn_more_url={url}
            type={type}
            btnLabel={btnLabel}
            btnLink={btnLink}
          />
          <div className="img-container" style={{ paddingLeft: stylePadding ? stylePadding : 'none' }}>
            <img src={productImage} alt={featureTitle} />
          </div>

      </div>
    </div>
    <div className="lowScreen">
      <div
        className={`solution-item ${imageDirection ? imageDirection : ""} ${
          hack ? hack : ""
        }`}
        style={{ textAlign: "center" }}
      > 
          <div className="img-container" style={{ paddingLeft: stylePadding ? stylePadding : 'none' }}>
            <img src={productImage} alt={featureTitle} />
          </div>
          <Description
            title={featureTitle}
            descriptionText={featureDescription}
            descriptionText2={featureDescription2}
            descriptionText3={featureDescription3}
            list={list}
            learn_more_url={url}
            type={type}
            btnLabel={btnLabel}
            btnLink={btnLink}
          />

      </div>
    </div>
    </>
  )
}
const NewProducts = ({ withTitle, features, homePage, type }) => {
  //console.log(features, "features")
  // let featureListOne, featureListTwo
  // if (homePage && features) {
  //   featureListOne = features.slice(0, 2)
  //   featureListTwo = features.slice(2)
  // }
  return (
    <div className={`products ${withTitle ? "withTitle" : ""}`}>
      {withTitle && <h3 className="title">{withTitle}</h3>}
      <div className="solutions-area">
        {features &&
          homePage &&
          features.map((feature, index) => {
            return (
              <SolutionFeature
                key={index}
                featureTitle={feature.featureTitle}
                featureDescription={feature.featureDescription}
                featureDescription2={feature.featureDescription2}
                featureDescription3={feature.featureDescription3}
                list={feature.list}
                productImage={feature.featureImage}
                imageDirection={feature.imagePosition}
                hack={feature.hack}
                url={feature.url}
                stylePadding={feature.stylePadding}
                btnLabel={feature.btnLabel}
                btnLink={feature.btnLink}
                type={type}
              />
            )
          })}

        {/* {homePage && (
          <React.Fragment>
            {featureListOne.map((feature, index) => {
              return (
                <SolutionFeature
                  key={index}
                  featureTitle={feature.featureTitle}
                  featureDescription={feature.featureDescription}
                  productImage={feature.featureImage}
                  imageDirection={feature.imagePosition}
                  url={feature.url}
                />
              )
            })}
            <Accordion className="show-more-accordion">
              <Accordion.Collapse eventKey="0">
                <div>
                  {featureListTwo.map((feature, index) => {
                    return (
                      <SolutionFeature
                        key={index}
                        featureTitle={feature.featureTitle}
                        featureDescription={feature.featureDescription}
                        productImage={feature.featureImage}
                        imageDirection={feature.imagePosition}
                        hack={feature.hack}
                        url={feature.url}
                      />
                    )
                  })}
                </div>
              </Accordion.Collapse>
              <Toggle eventKey="0">
                <p className="show-more">
                  <span id="showMore">Show More</span>
                  <span>
                    <img src={ShowMoreIcon} alt="show more" />
                  </span>
                </p>
              </Toggle>
            </Accordion>
          </React.Fragment>
        )} */}
      </div>
    </div>
  )
}
export default NewProducts
